export default __webpack_public_path__ + "static/media/chillpill_preview.png";